import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import relativeTime from "dayjs/plugin/relativeTime"
import calendar from "dayjs/plugin/calendar"
import localizedFormat from "dayjs/plugin/localizedFormat"
import "dayjs/locale/ar"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.tz.setDefault("Africa/Cairo")

dayjs.locale("ar")

export { dayjs }

export function formatDateForDisplay(time: number, format = "D MMMM • hh:mm a") {
  const result = dayjs.unix(time).locale("ar").format(format)
  return result.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[Number.parseInt(d, 10)]).replace(/AM|PM/i, (ampm) => (ampm.toLowerCase() === "am" ? "ص" : "م"))
}

export function formatDateForApi(date: Date) {
  return dayjs(date).utc().unix()
}

/** Convert unix timestamp to local Date for display in DatePicker */
export function unixToLocalDate(unix: number): Date {
  return dayjs.unix(unix).toDate()
}

/** Convert local Date from DatePicker to UTC unix timestamp for API */
export function localDateToUnix(date: Date): number {
  return dayjs(date).utc().unix()
}
